import styled, { css } from 'styled-components'
import { DRAG_HELPER_CLASS } from '../consts'

export const DragHandleContainer = styled.div`
  position: absolute;
  left: 0;
  top: -1px;
  height: calc(100% + 2px);
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateX(calc(-100% - 1px));
  border-bottom-left-radius: var(--radius-brand);
  border-top-left-radius: var(--radius-brand);
  border: 1px solid var(--border-secondary);
  border-right: 0;
  background: var(--bg-transparent);
  opacity: 0;
  user-select: none;
`

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;

  padding: 8px 4px;
  border-radius: var(--radius-brand);

  color: var(--icon-secondary);

  cursor: move;
  cursor: grab;

  &:hover {
    color: var(--icon-primary);
  }
`

export const Options = styled.div`
  display: flex;
  align-items: center;

  opacity: 0;
`

export const Wrapper = styled.div<{
  $hoverable: boolean
  $sortable: boolean
  $isDragging: boolean
  $highlighted: boolean
}>`
  background: var(--bg-primary);
  border-left: 1px solid var(--border-secondary);
  border-right: 1px solid var(--border-secondary);
  border-bottom: 1px solid var(--border-secondary);

  ${({ $sortable, $isDragging }) =>
    $sortable &&
    !$isDragging &&
    css`
      &:hover {
        border-left-color: transparent;

        ${DragHandleContainer}, ${Options} {
          opacity: 1;
        }
      }
    `};

  ${({ $hoverable, $isDragging }) =>
    $hoverable &&
    !$isDragging &&
    css`
      cursor: pointer;

      &:hover {
        background: var(--bg-transparent);
      }

      &:active {
        background: var(--bg-transparent-strong);
      }
    `};

  ${({ $highlighted }) =>
    $highlighted &&
    css`
      background: var(--bg-brand-secondary);
    `};

  &:last-child {
    border-bottom-right-radius: var(--radius-brand);
    border-bottom-left-radius: var(--radius-brand);
  }

  &.${DRAG_HELPER_CLASS} {
    border-top: 1px solid var(--border-secondary);
    border-left-color: transparent;
    border-radius: var(--radius-brand);
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);

    ${DragHandleContainer} {
      opacity: 1;
      height: calc(100% + 1px);
      background: var(--bg-primary);
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);
      clip-path: inset(-2px 0px -2px -2px);
    }

    ${DragHandle} {
      background: var(--bg-transparent);
    }
  }
`

export const Row = styled.div`
  position: relative;
  display: flex;
  align-items: stretch;
  padding: 0 var(--space-200);
  cursor: inherit;
`

export const ChildrenContainer = styled.div`
  flex: 1;
`

export const Children = styled.div`
  display: flex;
  align-items: stretch;
`

export const Footer = styled.footer`
  background: var(--bg-primary);
`
